export interface INumTitles {
    firstTitle: number
    lastTitle: number
    isRedirect: boolean
}

export const getNumTitles = (countAllTitles: number, currentPage: number, limit: number): INumTitles => {
    let isRedirect = false
    let firstTitle
    let lastTitle

    if (currentPage * limit > countAllTitles) {
        if (currentPage * limit - limit < countAllTitles) {
            const diff = currentPage * limit - countAllTitles

            firstTitle = (currentPage - 1) * limit + 1
            lastTitle = currentPage * limit - diff
        } else {
            // page not found = > redirect to page1
            isRedirect = true
            firstTitle = 1
            lastTitle = limit
            if (countAllTitles < limit) {
                lastTitle = countAllTitles
            }
        }
    } else {
        firstTitle = (currentPage - 1) * limit + 1
        lastTitle = currentPage * limit
    }

    return {
        firstTitle,
        lastTitle,
        isRedirect,
    }
}
